import { Shield, Mail, FileText } from "lucide-react";

export function LgpdFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Shield className="h-4 w-4" />
            <span>&copy; {year} IndiQR. Todos os direitos reservados.</span>
          </div>

          <div className="flex flex-col items-center gap-2 text-sm text-muted-foreground md:items-start">
            <div className="flex items-center gap-1.5">
              <Mail className="h-3.5 w-3.5" />
              <span>DPO: <a href="mailto:dpo@indiqr.com.br" className="underline-offset-4 hover:text-foreground hover:underline">dpo@indiqr.com.br</a></span>
            </div>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href="/privacidade/politica-de-privacidade.html"
              className="inline-flex items-center gap-1 text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
            >
              <FileText className="h-3.5 w-3.5" />
              Política de Privacidade
            </a>
            <span className="text-muted-foreground/40 hidden sm:inline">|</span>
            <a
              href="/privacidade/solicitacao"
              className="text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
            >
              Seus Direitos (LGPD)
            </a>
            <span className="text-muted-foreground/40 hidden sm:inline">|</span>
            <button
              type="button"
              onClick={() => {
                localStorage.removeItem("lgpd-consent");
                window.dispatchEvent(new Event("lgpd-consent-reset"));
              }}
              className="text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
            >
              Preferências de Cookies
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
}
